function paymentsMethod(tickets, paymentsMethod) {
    const opposite = paymentsMethod==='monthly'?'payments':'monthly';
    let oppositeArr = tickets.tickets.filter((i) => {     
        return i?.payments?.paymentsMethod === opposite && i?.payments?.hasBillings===1 && i.tid !== tickets.currentTicket.tid; 
    });
    return oppositeArr;
}

export default paymentsMethod;